/**
 * @generated SignedSource<<a10040748a2910adfee2c2a1c7d05f86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HubspotIntegration_viewer$data = {
  readonly account: {
    readonly billingAccount: {
      readonly hasAccessToHubspotFeature: boolean;
    };
    readonly integrations: {
      readonly hubspot: {
        readonly accountConnected: boolean;
        readonly userConnected: boolean;
      } | null;
    };
    readonly primaryAdmin: {
      readonly fullName: string;
    } | null;
  };
  readonly hasAccessToCopilot: boolean;
  readonly integrations: {
    readonly hubspot: {
      readonly associateWithRelatedDeals: boolean;
      readonly autoSendNotesEnabled: boolean;
      readonly createHubspotTasksFromActionItems: boolean;
      readonly includeRecapInAutoSendNotes: boolean;
      readonly isConnected: boolean;
    } | null;
    readonly salesforce: {
      readonly isConnected: boolean;
    } | null;
  };
  readonly user: {
    readonly internalAttributes: {
      readonly isAccountAdmin: boolean;
    } | null;
  };
  readonly " $fragmentType": "HubspotIntegration_viewer";
};
export type HubspotIntegration_viewer$key = {
  readonly " $data"?: HubspotIntegration_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HubspotIntegration_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HubspotIntegration_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAccessToCopilot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserInternalAttributes",
          "kind": "LinkedField",
          "name": "internalAttributes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAccountAdmin",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "primaryAdmin",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountIntegrations",
          "kind": "LinkedField",
          "name": "integrations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "HubspotAccountNode",
              "kind": "LinkedField",
              "name": "hubspot",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "accountConnected",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userConnected",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": "hasAccessToHubspotFeature",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "hubspot_integration"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"hubspot_integration\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserIntegrations",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "HubspotUserNode",
          "kind": "LinkedField",
          "name": "hubspot",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "autoSendNotesEnabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "associateWithRelatedDeals",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "includeRecapInAutoSendNotes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createHubspotTasksFromActionItems",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SalesforceUserNode",
          "kind": "LinkedField",
          "name": "salesforce",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "70d596992c7e3cce2048ded5a94cdd5a";

export default node;
